import { useState } from 'react';
import { Box, Icon, Paragraph, Text, Tooltip } from '@zillow/constellation-10';
import { IconInfoOutline } from '@zillow/constellation-icons';

export interface HeaderTooltipProps {
  title: string;
  message: string | JSX.Element;
  titleFlex?: string;
}

export const HeaderTooltip = ({ title, message, titleFlex = '0 0 auto' }: HeaderTooltipProps) => {
  const [open, setOpen] = useState(false);

  const tooltipContent = (
    <>
      <Paragraph textStyle="body-bold">{title}</Paragraph>
      <Text textStyle="body" css={{ textAlign: 'justify' }}>
        {message}
      </Text>
    </>
  );

  return (
    <Box
      css={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        gap: '100',
      }}
    >
      <Box css={{ flex: titleFlex }}>{title}</Box>
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip.Root open={open} onOpenChange={(isOpen) => setOpen(isOpen)} placement="top">
          <Tooltip.Trigger>
            <Icon css={{ cursor: 'help' }}>
              <IconInfoOutline />
            </Icon>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            {/* oxlint-disable-next-line constellation/no-raw-spacing-values */}
            <Tooltip.Content css={{ maxWidth: '300px' }}>
              {tooltipContent}
              <Tooltip.Arrow />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Box>
    </Box>
  );
};
